"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AmpStateContext = void 0;
var _interop_require_default = require("@swc/helpers/lib/_interop_require_default.js").default;
var _react = _interop_require_default(require("react"));
const AmpStateContext = _react.default.createContext({});
exports.AmpStateContext = AmpStateContext;
if (process.env.NODE_ENV !== 'production') {
    AmpStateContext.displayName = 'AmpStateContext';
}

//# sourceMappingURL=amp-context.js.map